import "./Cart.css";
import { useContext } from "react";
import React from "react";
import { Grid } from "@material-ui/core";
import { Button } from "@material-ui/core";
import CartItem from "../../components/CartItem/CartItem";
import DeleteIcon from "@material-ui/icons/Delete";
import { CartContext } from "../../contexts/MovieContext";
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';

const Cart = () => {

  const [context, setContext] = useContext(CartContext);
  let subTotal = context.reduce(function (acc, curr) {
    return acc + curr.price;
  }, 0);

  const removeItem = (id, e) => {
    let index = context.findIndex((item) => item.id === id);
    context.splice(index, 1);
    setContext([...context]);
    localStorage.setItem("cart", JSON.stringify(context));
  };

  const handleAddQty = (id) => {
    const exist = context.find((x) => x.id === id);
    let existPrice;
    if (exist.vote_average <= 5) {
      existPrice = 5000;
    } else {
      existPrice = 7500;
    }
    if (exist) {
      const updated = context.map((item) =>
        item.id === id
          ? { ...exist, qty: exist.qty + 1, price: item.price + existPrice }
          : item
      );
      setContext(updated)
      localStorage.setItem("cart", JSON.stringify(updated));
    }
  };

  const handleSubstractQty = (id) => {
    const exist = context.find((x) => x.id === id);
    let existPrice;
    if (exist.vote_average <= 5) {
      existPrice = 5000;
    } else {
      existPrice = 7500;
    }
    if (exist.qty === 0) {
      removeItem(id);
    }

    if (exist) {
      const updated = context.map((item) =>
        item.id === id
          ? { ...exist, qty: exist.qty - 1, price: item.price - existPrice }
          : item
      );
      setContext(updated)
      localStorage.setItem("cart", JSON.stringify(updated));
    }
  };
  return (
    <div>
      <span className="pageTitle">Cart</span>
      <Grid container spacing={4}>
        {context.map((val, idx) => (
          <Grid item lg={3} md={4} sm={2} key={idx}>
            <CartItem data={val} />
            <div className="btnAction">
              <Button
                className="btnRemove"
                onClick={(e) => removeItem(val.id, e)}
              >
                <DeleteIcon />
              </Button>
              <div className="addition">
                <AddIcon className="btnAdd" onClick={() => handleAddQty(val.id)}
                  style={{ color: '#fff', width: '28px', height: '28px' }}></AddIcon>
                <p>{val.qty}</p>
                <RemoveIcon className="btnMin"
                  onClick={() => handleSubstractQty(val.id)} style={{ color: '#fff', width: '28px', height: '28px' }}></RemoveIcon>
              </div>
            </div>
          </Grid>
        ))}
      </Grid>
      <h3 className="subTotal">Subtotal: IDR.{subTotal}</h3>
    </div>
  );
};

export default Cart;



// WEBPACK FOOTER //
// ./src/Pages/Cart/Cart.js